import { useEffect } from 'react';
import { pushDatalayer } from 'js/utilities';

export default function ConversionFlowDatalayer({ flow, activeStepId, datalayerData = {} }) {
    useEffect(() => {
        const activeStep = flow?.steps?.find(step => step.id === activeStepId) || null;
        if (!activeStep) return;

        const datalayer = {
            form_step: activeStep.last ? 'voltooid' : `${activeStep?.position}`,
            form_id: `flow-${flow?.flowId}`,
            form_name: `${flow?.summary?.datalayer?.form_name}`,
            form_category: `${flow?.summary?.datalayer?.form_category || ''}`,
            form_type: `${flow?.summary?.datalayer?.form_type || ''}`,
            form_priority: `${flow?.summary?.datalayer?.form_priority || ''}`,
            event: (activeStep.last && flow?.summary?.datalayer?.form_priority === 'primair') ? 'purchase_leadgen' : 'form',
            ...datalayerData,
        }

        if (activeStep.last) {
            Object.assign(datalayer, {
                customer_email: (flow?.summary?.datalayer?.email && flow?.summary?.datalayer?.email !== '') ? flow?.summary?.datalayer?.email : null,
                phone_number: (flow?.summary?.datalayer?.phone && flow?.summary?.datalayer?.phone !== '') ? flow?.summary?.datalayer?.phone : null,
            });
        }

        pushDatalayer(datalayer);
    }, [activeStepId]);

    return null;
}
